import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import {
  EmailNotificationSegmentedControl,
  EmailNotificationSegmentedControlProps,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/SegmentedControl/EmailNotificationSegmentedControl';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { EmailNotificationRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/EmailNotificationRule/EmailNotificationRuleHeader';
import { withRow } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/withRow';

export type EmailNotificationRuleProps = Omit<
  AccordionProps,
  'header' | 'body'
>;

const EmailNotificationWithRow =
  withRow<EmailNotificationSegmentedControlProps>(
    EmailNotificationSegmentedControl
  );

export function EmailNotificationRule({
  ...props
}: EmailNotificationRuleProps): JSX.Element {
  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <EmailNotificationRuleHeader isActive={isActive} />
      )}
      body={(): JSX.Element => (
        <EmailNotificationWithRow
          id="sendLocWelcomeEmail"
          name="sendLocWelcomeEmail"
        />
      )}
    />
  );
}
